import {Box} from "@mui/system";
import DataSource from "../Utilities/DataSources/DataSource";
import styles from "../organizationMainStyles";
import {getLabel} from "../Utilities/organizationSettingsUtils";
import useGetDataSourceHandleInfo from "../hooks/useGetDataSourceHandleInfo";
import useGetTrendsDataSourceHandles from "../hooks/useGetTrendsDataSourceHandles";
import {fragmentId} from "../Utilities/organizationSettingsConstants";
import _ from "lodash";
import NoDataView from "../EmptyStates/NoDataView";
import React from "react";
import DataSourcesEmptyState from "../EmptyStates/DataSourcesEmptyState";
import {buildSortedDataSourceEntries} from "../Utilities/DataSources/dataSourcesUtils";

export default function DataSources({organizationId, organizationTrendsId}) {
    const label = getLabel(fragmentId.DATA_SOURCES);
    const {handleInfo, loading: loadingTeamsHandles} = useGetDataSourceHandleInfo(organizationId);
    const {trendsHandles, loading: loadingTrendsHandles} = useGetTrendsDataSourceHandles(organizationTrendsId);
    const loading = loadingTeamsHandles || (organizationTrendsId && loadingTrendsHandles);

    if(_.isEmpty(organizationId) && _.isEmpty(handleInfo)) {
        return <NoDataView />
    }

    if(loading) {
        return (
            <Box sx={styles.sectionWrapper}>
                <DataSourcesEmptyState/>
            </Box>
        )
    }

    const dataSourceEntries = buildSortedDataSourceEntries(handleInfo.items, trendsHandles);

    return (
        <Box sx={styles.sectionWrapper}>
            {
                dataSourceEntries.map((entry) =>
                    <DataSource
                        key={entry.key}
                        handle={entry.handle}
                        trendsHandle={entry.trendsHandle}
                        isTrendsOnly={entry.isTrendsOnly}
                        label={label}
                        organizationId={organizationId}
                        organizationTrendsId={organizationTrendsId}
                    />
                )
            }
        </Box>
    )
}